export default {
  API_URL: 'https://mitie-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://mitiesandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
